export * from "../../original/js/components/character-counter";

// soon to be depricated.
import { CharacterCounter } from '../../original/js/components/character-counter';

export default CharacterCounter
